import { createSelector } from '@ngrx/store';
import { selectTermDataState } from '..';

export const selectTerms = createSelector(selectTermDataState, (state) => state.terms);
export const selectLoadingStatus = createSelector(selectTermDataState, (state) => state.TermDataLoading);
